export const formatCurrency = (
  amount: number | null,
  locale = "en-US"
): string => {
  if (amount === null) return "--";
  const formattedNumber = amount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  // For French Canadian locale, place $ after the number with a space
  if (locale === "fr-CA") {
    return `${formattedNumber} $`;
  }

  // For English locales, place $ before the number
  return `$${formattedNumber}`;
};

export const parseCurrency = (value: string): number | null => {
  const cleaned = value.replace(/[^0-9.]/g, "");
  if (cleaned === "" || cleaned === ".") return null;
  const parsed = parseFloat(cleaned);
  if (isNaN(parsed)) return null;
  // Round to 2 decimal places
  return Math.round(parsed * 100) / 100;
};

export const validateFeeName = (name: string): boolean => {
  return name.trim().length > 0;
};

export const validateFeeAmount = (amount: number | null): boolean => {
  return amount === null || amount >= 0;
};
